import { useUserTrialDetails } from '@revelio/auth';
import type { TalentDiscoveryV2RespUser } from '@revelio/data-access';

import { WithTooltip } from '../../../../shared/components/with-tooltip';
import { SourceWhaleExportButton } from './source-whale/components/source-whale-export-button';

interface TalentDiscoverySourceWhaleButtonProps {
  disabled?: boolean;
  selectedRows?: Record<string, unknown>[];
}

export const TalentDiscoverySourceWhaleButton = ({
  disabled = false,
  selectedRows = [],
}: TalentDiscoverySourceWhaleButtonProps) => {
  const { isTrialUser } = useUserTrialDetails<boolean>({
    initialRenderValue: false,
  });

  return (
    <WithTooltip
      tooltipId="talent_discovery_sourcewhale_trial"
      showCondition={isTrialUser}
      placement="top"
      label="This feature is not available for trial users"
    >
      <div>
        <SourceWhaleExportButton
          disabled={isTrialUser || disabled}
          selectedUsers={(selectedRows || []).map(
            (r) => r.__metaData as TalentDiscoveryV2RespUser
          )}
        />
      </div>
    </WithTooltip>
  );
};
